// UI Management

import { TABS } from './config.js';

class UIManager {
  constructor() {
    this.currentTab = 'dashboard';
    this.sidebar = null;
    this.overlay = null;
    this.hamburger = null;
  }

  init() {
    this.sidebar = document.getElementById('sidebar');
    this.overlay = document.querySelector('.sidebar-overlay');
    this.hamburger = document.querySelector('.hamburger');

    this.setupEventListeners();
  }

  setupEventListeners() {
    // Hamburger click
    const hamburgers = document.querySelectorAll('[data-action="toggle-sidebar"]');
    hamburgers.forEach(h => h.addEventListener('click', () => this.toggleSidebar()));

    // Overlay click
    if (this.overlay) {
      this.overlay.addEventListener('click', () => this.toggleSidebar());
    }

    // Tab navigation
    const navItems = document.querySelectorAll('[data-tab]');
    navItems.forEach(item => {
      item.addEventListener('click', e => {
        e.preventDefault();
        const tab = item.getAttribute('data-tab');
        this.switchTab(tab);
      });
    });
  }

  toggleSidebar() {
    if (!this.sidebar) return;

    const isOpen = this.sidebar.classList.contains('open');

    if (isOpen) {
      this.sidebar.classList.remove('open');
      this.overlay?.classList.remove('active');
      this.hamburger?.classList.remove('active');
      document.body.classList.remove('sidebar-open');
    } else {
      this.sidebar.classList.add('open');
      this.overlay?.classList.add('active');
      this.hamburger?.classList.add('active');
      document.body.classList.add('sidebar-open');
    }
  }

  switchTab(tab) {
    if (!TABS.includes(tab)) {
      console.warn(`Invalid tab: ${tab}`);
      return;
    }

    // Update active states
    document.querySelectorAll('.menu-item').forEach(e => e.classList.remove('active'));
    document.querySelectorAll('.nav-item').forEach(e => e.classList.remove('active'));

    const tabIndex = TABS.indexOf(tab);
    if (tabIndex >= 0) {
      const menuItems = document.querySelectorAll('.menu-item');
      const navItems = document.querySelectorAll('.nav-item');
      menuItems[tabIndex]?.classList.add('active');
      navItems[tabIndex]?.classList.add('active');
    }

    // Show/hide tab content
    document.querySelectorAll('.tab-content').forEach(e => e.classList.remove('active'));
    const tabElement = document.getElementById(tab);
    if (tabElement) {
      tabElement.classList.add('active');
    }

    // Update titles
    this.updateTitles(tab);

    // Close sidebar on mobile
    if (window.innerWidth < 768) {
      this.sidebar?.classList.remove('open');
      this.overlay?.classList.remove('active');
      this.hamburger?.classList.remove('active');
      document.body.classList.remove('sidebar-open');
    }

    this.currentTab = tab;

    // Dispatch event for tab change
    window.dispatchEvent(new CustomEvent('tabchange', { detail: { tab } }));
  }

  updateTitles(tab) {
    const titles = {
      dashboard: {
        title: '📊 Dashboard',
        subtitle: 'Panoramica dei tuoi progressi',
      },
      training: {
        title: '🏋️ Allenamento',
        subtitle: 'Il tuo programma di allenamento personalizzato',
      },
      diet: {
        title: '🍽️ Piano Alimentare',
        subtitle: 'La tua dieta bilanciata',
      },
      progress: {
        title: '📈 Progress',
        subtitle: 'Analizza i tuoi miglioramenti',
      },
      timer: {
        title: '⏱️ Timer Rest',
        subtitle: 'Gestisci i tempi di recupero',
      },
    };

    const config = titles[tab];
    if (!config) return;

    const headerTitle = document.getElementById('headerTitle');
    const pageTitle = document.getElementById('pageTitle');
    const pageSubtitle = document.getElementById('pageSubtitle');

    if (headerTitle) {
      const shortTitle = config.title.split(' ').slice(0, 2).join(' ');
      headerTitle.textContent = shortTitle;
    }

    if (pageTitle) pageTitle.textContent = config.title;
    if (pageSubtitle) pageSubtitle.textContent = config.subtitle;
  }

  getCurrentTab() {
    return this.currentTab;
  }

  showLoading(containerId) {
    const container = document.getElementById(containerId);
    if (!container) return;

    let html = '<div class="loading-skeleton">';
    for (let i = 0; i < 3; i++) {
      html += `
        <div class="skeleton-card">
          <div class="skeleton-line"></div>
          <div class="skeleton-line short"></div>
          <div class="skeleton-grid">
            <div class="skeleton-box"></div>
            <div class="skeleton-box"></div>
            <div class="skeleton-box"></div>
            <div class="skeleton-box"></div>
          </div>
        </div>
      `;
    }
    html += '</div>';
    container.innerHTML = html;
  }

  showError(containerId, message = '❌ Errore caricamento dati') {
    const container = document.getElementById(containerId);
    if (!container) return;

    container.innerHTML = `
      <div class="loading-skeleton">
        <div style="text-align:center;padding:40px;color:var(--text-secondary);">
          ${message}
        </div>
      </div>
    `;
  }
}

export const ui = new UIManager();
